import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        background: color(theme.colors.violet_primary).fade(0.92).string(),
        padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
        borderRadius: theme.radius,
        maxWidth: '100%',
    },
    icon: {
        width: 20,
        height: 20,
        flexShrink: 0,
    },
    iconSmall: {
        width: 16,
        height: 16,
    },
    label: {
        margin: 0,
        fontFamily: theme.font.primary,
        fontSize: 13,
        lineHeight: 1.2,
        color: theme.colors.violet_primary,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));
